import { render, staticRenderFns } from "./EmailEventsDetail.vue?vue&type=template&id=37754c90&"
import script from "./EmailEventsDetail.vue?vue&type=script&lang=ts&"
export * from "./EmailEventsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports